import { EVENT_ICONS, eventIconLabel } from '@odo/shared-ui';
import { PresentationSelect, type PresentationSelectOption } from './PresentationSelect';

const ICON_KEYS = Object.keys(EVENT_ICONS);
const NONE_LABEL = 'None (no icon)';
const NONE_VALUE = '';

function IconGlyph({ iconKey }: { iconKey: string }) {
    const Icon = EVENT_ICONS[iconKey];
    return (
        <span className="flex h-5 w-5 flex-shrink-0 items-center justify-center text-gray-500">
            {Icon ? <Icon className="h-4 w-4" /> : <span aria-hidden="true">-</span>}
        </span>
    );
}

const ICON_OPTIONS: PresentationSelectOption[] = [
    { value: NONE_VALUE, label: NONE_LABEL, render: () => <IconGlyph iconKey={NONE_VALUE} /> },
    ...ICON_KEYS.map((key) => ({
        value: key,
        label: eventIconLabel(key),
        render: () => <IconGlyph iconKey={key} />
    }))
];

interface EventIconPickerProps {
    /** `''` means no icon (`iconKey: null`) - independent of `alignment`. */
    value: string;
    id: string;
    onChange: (key: string) => void;
    disabled?: boolean;
}

// A custom listbox so every one of the 24 icons renders its real glyph next
// to its label - a native `<select>` can't render an SVG inside an option.
export function EventIconPicker({ id, value, onChange, disabled }: EventIconPickerProps) {
    return (
        <PresentationSelect
            id={id}
            value={value}
            options={ICON_OPTIONS}
            onChange={onChange}
            disabled={disabled}
        />
    );
}
